import { BackendRoute } from '../../../config/index';
import { QueryKey } from '../../../constants/index';
import { useAppQuery, useInvalidateQueries } from '../../../hooks/index';
import { ApiService } from '../../../services/index';
import { selectedCompanyStorage } from '../../../storage/company/index';

export enum InvestmentType {
  FUNDRAISING_ROUND = 'fundraising-round',
  SAFE = 'safe',
}

export type InvestmentHistory = {
  documents: string[];
  id: string;
  investmentAmount: number;
  investmentDate: Date;
  ownership: number;
  postMoneyValuation: number;
  shareClassName: string;
  sharePrice: number;
  sharesCount: number;
  type: InvestmentType;
  valuationName: string;
};

type InvestmentHistoryProps = {
  enabled?: boolean;
  stakeholderId: string;
};

export const useInvestmentHistory = ({ enabled = true, stakeholderId }: InvestmentHistoryProps) => {
  const { invalidateQuery } = useInvalidateQueries(QueryKey.GET_INVESTMENT_HISTORY);
  const companyId = selectedCompanyStorage(({ companyId }) => companyId);
  const company = selectedCompanyStorage(({ company }) => company);
  const isCompanyContextReady = company?.id === companyId;
  const { data: investments = [], isLoading } = useAppQuery({
    queryKey: [QueryKey.GET_INVESTMENT_HISTORY, companyId, stakeholderId],
    queryFn: () =>
      ApiService.get<InvestmentHistory[]>({
        endpoint: BackendRoute.COMPANIES,
        routePath: [companyId, 'events', 'stakeholders', stakeholderId, 'investment-history'],
      }),
    enabled: enabled && isCompanyContextReady && Boolean(companyId) && Boolean(stakeholderId),
  });

  return {
    isLoading,
    invalidateQuery,
    investments,
  };
};
